export const IS_BKASH_OFFER_MENU_ACTIVE = false;
